import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { renewSubscription } from "../../redux/services/SubscriptionServices/Subscription.Services";
import { errorToast, successToast } from "../../Utils/toast";
import { closeModal } from "../../redux/features/modalSlice";

function RenewSubscription({ data: subscription, onSuccess }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    payment_amount: subscription?.price ?? "",
    payment_method: "cash",
    payment_id: "",
    extend_days: subscription?.duration_days ?? 30,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
  const totalPrice = Number(subscription?.price || 0);
  const paidAmount = Number(form.paid_amount || 0);
  const dueAmount = totalPrice - paidAmount;



  const validate = () => {
    const err = {};

    if (
      form.payment_amount === "" ||
      isNaN(Number(form.payment_amount)) ||
      Number(form.payment_amount) <= 0
    ) {
      err.payment_amount = "Valid payment amount is required";
    }

    if (
      form.extend_days === "" ||
      isNaN(Number(form.extend_days)) ||
      Number(form.extend_days) < 1
    ) {
      err.extend_days = "Extend days must be at least 1";
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;


    try {
      setLoading(true);
      const payload = {
        subscription_id: subscription.id,
        payment_amount: Number(form.payment_amount),
        payment_method: form.payment_method,
        payment_id: form.payment_id,
        extend_days: Number(form.extend_days),
      };

      const res = await renewSubscription(payload);
      successToast(res?.message || "Subscription renewed successfully");

      dispatch(closeModal());
      onSuccess?.();
    } catch (error) {
      console.log(error);
      errorToast(
        error?.response?.data?.message || "Failed to renew subscription"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {subscription ? (
        <div className="alert alert-info mb-4">
          <div>
            <strong>Vendor:</strong>{" "}
            {subscription?.vendor?.name ||
              subscription?.vendor?.mobile ||
              subscription?.user_id ||
              "-"}
          </div>
          <div>
            <strong>Plan:</strong> {subscription?.name || "-"}
          </div>
          <div>
            <strong>Duration:</strong>{" "}
            {subscription?.duration_days
              ? `${subscription.duration_days} days`
              : "-"}
          </div>
          <div>
            <strong>Price:</strong>{" "}
            {subscription?.price ? `₹${subscription.price}` : "-"}
          </div>
        </div>
      ) : (
        <div className="alert alert-danger mb-4">
          Subscription data not available.
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Payment Amount *</label>
            <input
              type="number"

              className={`form-control ${errors.payment_amount ? "is-invalid" : ""}`}
              name="payment_amount"
              value={form.payment_amount}
              onChange={handleChange}
              placeholder="Enter amount"
            />
            {errors.payment_amount && (
              <div className="invalid-feedback">{errors.payment_amount}</div>
            )}

          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Extend Days </label>
            <input
              type="number"
              className="form-control"
              name="extend_days"
              value={form.extend_days}
              onChange={handleChange}
              placeholder="e.g. 30"
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Payment Method</label>
            <select
              className="form-control"
              name="payment_method"
              value={form.payment_method}
              onChange={handleChange}
            >
              <option value="cash">Cash</option>
              <option value="online">Online</option>
              <option value="upi">UPI</option>
              <option value="card">Card</option>
            </select>
          </div>

          {/* <div className="col-md-6 mb-3">
            <label className="form-label">Payment ID</label>
            <input
              type="text"
              className="form-control"
              name="payment_id"
              value={form.payment_id}
              onChange={handleChange}
              placeholder="e.g. MANUAL_004"
            />
          </div> */}
        </div>

        <div className="d-flex gap-2 mt-3">
          <button type="submit" className="add-btn" disabled={loading}>
            {loading ? "Renewing..." : "Renew Plan"}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => dispatch(closeModal())}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default RenewSubscription;